const config = {
  server_base_url: process.env.NODE_ENV=='development' ? "http://localhost:5020" : "https://nivas.mooji.org",
  stripe_public_key: process.env.NODE_ENV=='development' ? "pk_test_xEzRH68aPu1VfgJyqXIcEMrV" : "pk_live_pM8S6RvndFZBBZVPRqd90vJa",
};

module.exports = config;